import { Breakpoint, Color, FontWeight, Markdown, Shape } from '@elearning-platform/ui';
import { styled } from 'styled-components';

export const Container = styled.div`
  width: 100%;

  /* TODO: fix resetting border and bg for buttons in global styles */
  .showMore {
    border: none;
    background-color: ${Color.Transparent};
  }
`;

export const FiltersContainer = styled.div`
  padding: 40px 16px;

  @media ${Breakpoint.SmallDesktop} {
    padding: 56px 80px;
  }
`;

export const FiltersShapeContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const FiltersShape = styled(Shape)`
  width: 68px;
  height: 68px;
`;

export const CalendarSection = styled.div`
  padding-right: 0;
  width: 100%;

  @media ${Breakpoint.Tablet} {
    padding-right: 0;
  }

  @media ${Breakpoint.SmallDesktop} {
    padding-right: 80px;
  }
`;

export const EventsSection = styled.div`
  width: 100%;
  padding: 24px 16px 40px;
  gap: 40px;
  display: flex;
  flex-direction: column;

  @media ${Breakpoint.Tablet} {
    padding: 64px 40px 40px;
  }

  @media ${Breakpoint.SmallDesktop} {
    padding: 64px 80px 40px;
  }
`;

export const EventsGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 64px;
`;

export const BgImageContainer = styled.div`
  width: 100%;
`;

export const BgImage = styled.img`
  width: 100%;
  height: 160px;
  object-fit: none;
  object-position: top center;

  @media ${Breakpoint.Tablet} {
    height: 180px;
    object-fit: unset;
    object-position: initial;
  }

  @media ${Breakpoint.SmallDesktop} {
    height: 240px;
  }
`;

export const Title = styled(Markdown)`
  strong {
    color: ${Color.Gray500};
    font-weight: ${FontWeight.Regular};
  }
  color: ${Color.Gray700};
`;
